var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankTiming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_timing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9898\\u5E93-\\u5355\\u9009\\u9898",
    transform: "translate(-1005, -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_timing",
    transform: "translate(1004, 141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,3 C12.5367575,3 15.3428371,4.62009079 16.8612159,7.24999996 C18.3795947,9.87990913 18.3795947,13.1200909 16.8612159,15.75 C15.3428371,18.3799092 12.5367575,20 9.5,20 C4.8055796,20 1,16.1944204 1,11.5 C1,6.80557963 4.8055796,3 9.5,3 Z M9.49999994,7 C8.99302511,7.00006689 8.566316,7.37950712 8.50699994,7.88300001 L8.49999994,8 L8.49999994,11 L8.50699994,11.117 C8.56683636,11.6200509 8.99340289,11.9988856 9.49999994,11.9988856 C10.006597,11.9988856 10.4331635,11.6200509 10.4929999,11.117 L10.4999999,11 L10.4999999,8 L10.4929999,7.88300001 C10.4336839,7.37950712 10.0069748,7.00006689 9.49999994,7 Z M13.4999999,0 C14.0290933,0.000586894662 14.4661646,0.413210491 14.4971719,0.941394821 C14.5281792,1.46957915 14.1423903,1.93050915 13.6169999,1.99300001 L13.4999999,2 L5.50299996,2 C4.9739066,1.99941312 4.53683524,1.58678952 4.50582793,1.05860519 C4.47482062,0.530420863 4.86060961,0.0694908645 5.38599996,0.00700000781 L5.50299996,0 L13.4999999,0 L13.4999999,0 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFA30C",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankTiming);
export default __webpack_public_path__ + "static/media/icon_questionbank_timing.svg";
export { ForwardRef as ReactComponent };